import React from 'react';

import ICONS from '../../assets/icons'
import useTextCorrection from "../../hooks/useTextCorrection";
import StyledList, {MainElementComponent as MainElement, ListElementComponent as ListElement} from "../styledList";

interface ActionTypeListProps {
  actions: {
    Action: string,
    ActionCode: string
  }[],
  change: (action: string) => {},
  filter: {},
}

const ActionTypeList:React.FC<ActionTypeListProps> = ({actions, change, filter}) => {
  const { filterText } = useTextCorrection();

  return (
    <StyledList>
      {
        actions.length > 0 &&
          actions.map(action => {
            return (
              <ListElement onClick={() => {
                change(action.Action)
              }}>
                <MainElement data={filter} value={action.Action}>
                  <p value={action.Action}>{filterText(action.Action)}</p>
                  <ICONS.check/>
                </MainElement>
              </ListElement>
            )
          })
      }
    </StyledList>
  )
};

export default ActionTypeList;

